export const RESPONSE_ERROR_PATH = {
  CurrentPassword: "current_password",
  Password: "password",
};
